import { ERROR_TYPES } from 'layers/content/constants'

/**
 * Stable lookup key for a row in `curriculumContentManager.content` (Redux state),
 * not a separate HTTP or memory cache.
 */
export function createCurriculumContentStateKey(
  contentGroupCode,
  routePath,
  siteId,
) {
  return `${contentGroupCode}::${routePath}::${siteId}`
}

const emptySelection = {
  route: null,
  page: null,
  coursePointer: null,
  resolvedInputs: null,
  siteContexts: null,
}

const selectCurriculumContent = (
  contentGroupCode,
  routePath,
  siteId,
) => state => {
  try {
    const contentStateKey = createCurriculumContentStateKey(
      contentGroupCode,
      routePath,
      siteId,
    )
    const manager = state.curriculumContentManager
    const entry = manager?.content?.[contentStateKey]
    const loading = manager?.isFetching

    if (!entry || !entry.data) {
      return {
        ...emptySelection,
        error: entry?.error
          ? {
              message: entry.error,
              errorType: ERROR_TYPES.contentServiceError,
            }
          : null,
        loading,
      }
    }

    const { data } = entry
    return {
      route: data.route || null,
      page: data.page || null,
      coursePointer: data.course_pointer || data.coursePointer || null,
      resolvedInputs: data.resolved_inputs || data.resolvedInputs || null,
      siteContexts: data.site_contexts || data.siteContexts || null,
      error: null,
      loading: false,
    }
  } catch (cause) {
    return {
      ...emptySelection,
      error: {
        message: cause?.message || 'Curriculum content selection failed',
        errorType: ERROR_TYPES.curriculumContentSelectorError,
      },
      loading: false,
    }
  }
}

export default {
  selectCurriculumContent,
}
